import axios from 'axios';
import { logger } from '../../../../lib/logger';
import { VALIDATE_API } from './constants';
import { withRetryOnTimeout } from './withRetryOnTimeout';

export const STATUS = {
    FREE: 'free',
    TAKEN: 'taken',
    SERVICE_ERROR: 'service_error',
};

export const isEmailAvailable = (email) => {
    const params = {
        email,
    };

    return withRetryOnTimeout(() => axios.get(VALIDATE_API, { params }))
        .then((response) => {
            const { status, data } = response;

            logger.info('Email check', {
                response: {
                    status,
                    body: data,
                },
            });

            return response;
        })
        .then(({ data }) => (data.message.email === 'Free' ? STATUS.FREE : STATUS.TAKEN))
        .catch((error) => {
            const { message, response } = error;
            const status = response?.status;
            const data = response?.data;

            logger.error('Email check failed', {
                error: {
                    message,
                },
                response: {
                    status,
                    body: data,
                },
            });

            throw error;
        })
        .catch(() => STATUS.SERVICE_ERROR);
};
